import React, { useEffect, useRef,useState } from "react";
import HomeBanner from "../../../images/background/homeBanner.jpg"
import { ToastContainer,toast } from "react-toastify";
import axios from "axios";
import "../../../css/header.css";
import "../../../css/bootstrap.css";
import "../../../css/element.css";
import "../../../css/flaticon.css";
import "../../../css/font-awesome.css";
import "../../../css/global.css";
import "../../../css/responsive.css";
import "../../../css/style.css";
import Header from "../../../components/User/Header/Header";
import Footer from "../../../components/User/Footer/Footer";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
 faShieldHalved,
 faUsers,
 faLaptop,
 faCartFlatbedSuitcase,
 faRupeeSign,
 faIndianRupeeSign,
 faHourglassStart,
 faArrowRight,
 faArrowLeft
} from "@fortawesome/free-solid-svg-icons";
// import  "../../js/jquery.js"
// import  "../../js/script.js"
// import  "../../js/bootstrap.js"
// import  "../../js/bxslider.js"
// // import  "../../js/gmaps.js"
// import  "../../js/jquery.fancybox-media.js"
// import  "../../js/jquery.fancybox.pack.js"
// import  "../../js/main-slider-script.js"
// import  "../../js/map-script.js"
// import  "../../js/plugins.js"


function Home() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const baseAPI = process.env.REACT_APP_API_URL;
  const[formData,setFormData]=useState({
    firstName:"",
    lastName:"",
    email:"",
    message:""
  })
  useEffect(()=>{
window.scrollTo(0,0)
  },[])
 const testimonials = [
  {
    text: `I recently used CARRYMYBAGGAGE service from Delhi to Singapore and I must recommend it. The on-ground team was professional and kept me updated during the journey. All my fragile items were intact and well-packaged. The entire process is very friendly as everything can be easily done using their website. Heavy baggage travel is no more a concern. Kudos CARRYMYBAGGAGE.`,
    author: "Nitansh Bhardwaj",
  },
  {
    text: `Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
laborum.sed ut perspiciatis unde.`,
    author: "Aarav Sharma",
  },
  {
    text: `Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est
laborum.sed ut perspiciatis unde.`,
    author: "Meera Kapoor",
  },
];
const  currentTestimonial= testimonials[currentIndex];


  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const chooseUsSection=useRef(null)
  const whatMakesUsDifferent=useRef(null)

  const scrollToChooseUsSection=()=>{
    chooseUsSection.current.scrollIntoView({ behavior: "smooth" });
  }

  const scrollToWhatMakesDiffSection=()=>{
    whatMakesUsDifferent.current.scrollIntoView({ behavior: "smooth" });
  }

  const handleChange=(e)=>{
    const{name,value}=e.target
setFormData({...formData,[name]:value})
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
   if(formData.email===''){
    return  toast.error('Email Address is missing', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light"
          });
   }
      try {
        const response = await axios.post(
          `${baseAPI}/CMB/AddAppointmentData`,
          formData
        );
        toast.success('Form Submitted Successfully', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: 'Bounce',
          });
          setFormData({ firstName:"",
            lastName:"",
            email:"",
            message:""})
      } catch (error) {
        console.error("Error posting data:", error);
      }
  };

  return (
    <div>
      <div className="page-wrapper">
        <Header />
        {/* Hero Section  */}
        <section
          className="call-to-action-one sp-four"
          style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div className="container">
            <div className="sec-title-one white">
              {/* <h5>Keep Runing</h5> */}
              <h2> Leave The Baggage to Us </h2>
            </div>
            <div className="text mt-20 mb-50">
            Travelling can be tiring, especially with loads of baggage and extra charges; let us lighten your load <br /> Enjoy a Burden-Free Journey with Carry My Baggage , with end-to-end baggage solutions for every trip
            </div>
            <div className="link-btn">
              <Link className="theme-btn btn-style-two">
                Get Appointment
              </Link>
            </div>
          </div>
        </section>

        {/* What Makes Us Different  */}
        <section ref={whatMakesUsDifferent} className="service-section grey-bg sp-two">
          <div className="container">
            <div className="sec-title-one centered">
              {/* <h5>Our Qualification</h5> */}
              <h2>
                <span>Pack Heavy, </span> Travel Light.
              </h2>
              <div className="text mb-45">
               <p>

                 With Carry My Baggage's world-class shipment services, you can
                travel stress-free while having all your possessions by your
                side. We're by your side, worldwide.
               </p>
              
              </div>
            </div>
            <div className="row">
          
              <div className="services-block-one services-block-one-mobile col-xl-3 col-md-6 col-sm-12">
                <div className="inner-box text-center">
                  <div className="icon-box">
                    <span className="flaticon-weightlifting"></span>
                    <img
                      src={require("../../../images/resource/Cost_Effective_Solution.png")}
                      alt=""
                    />                  </div>
                  <a href="single-service.html" className="tran4s">
                    <h6>Cost effective solution</h6>
                  </a>
                  <div
                    style={{
                      borderBottom: "none",
                      boxShadow: "0 0 0px 0px rgba(0, 0, 0, 0)",
                    }}
                    className="py-0 testimonial-item-two"
                  >
                    <p>
                    Carrymybaggage offers fast delivery, international shipping, and door-to-door service for excess baggage.
                    </p>
                  </div>
                  {/* <div className="link-btn">
                    <a href="#" className="theme-btn btn-style-four">
                      Read More
                    </a>
                  </div> */}
                </div>
              </div>
              <div className="services-block-one services-block-one-mobile col-xl-3 col-md-6 col-sm-12">
                <div className="inner-box text-center">
                  <div className="icon-box">
                    <span className="flaticon-yoga"></span>
                    <img
                      src={require("../../../images/resource/Timely_Delivery_Everytime.png")}
                      alt=""
                    />      
                  </div>
                  <a href="single-service.html" className="tran4s">
                    <h6>Timely delivery every time</h6>
                  </a>
                  <div
                    style={{
                      borderBottom: "none",
                      boxShadow: "0 0 0px 0px rgba(0, 0, 0, 0)",
                    }}
                    className="py-0 testimonial-item-two"
                  >
                    <p>
                    Carrymybaggage helps you get hassle-free, safe, and timely delivery of your baggage.
                    </p>
                  </div>
                  {/* <div className="link-btn">
                    <a href="#" className="theme-btn btn-style-four">
                      Read More
                    </a>
                  </div> */}
                </div>
              </div>
              <div className="services-block-one services-block-one-mobile col-xl-3 col-md-6 col-sm-12">
                <div className="inner-box text-center">
                  <div className="icon-box">
                    <span className="flaticon-sneakers"></span>
                    <img
                      src={require("../../../images/resource/Transparency_in_Service.png")}
                      alt=""
                    />      
                  </div>
                  <a href="single-service.html" className="tran4s">
                    <h6>Transparency in service</h6>
                  </a>
                  <div
                    style={{
                      borderBottom: "none",
                      boxShadow: "0 0 0px 0px rgba(0, 0, 0, 0)",
                    }}
                    className="py-0 testimonial-item-two"
                  >
                    <p>
                    Stay informed with real-time updates and clear communication throughout the journey.
                    </p>
                  </div>
                  {/* <div className="link-btn">
                    <a href="#" className="theme-btn btn-style-four">
                      Read More
                    </a>
                  </div> */}
                </div>
              </div>
              <div className="services-block-one services-block-one-mobile col-xl-3 col-md-6 col-sm-12">
                <div className="inner-box text-center">
                  <div className="icon-box">
                    <span className="flaticon-sneakers"></span>
                    <img
                      src={require("../../../images/resource/Insurance_on_Demand.png")}
                      alt=""
                    />      
                  </div>
                  <a href="single-service.html" className="tran4s">
                    <h6>Insurance on-demand</h6>
                  </a>
                  <div
                    style={{
                      borderBottom: "none",
                      boxShadow: "0 0 0px 0px rgba(0, 0, 0, 0)",
                    }}
                    className="py-0 testimonial-item-two"
                  >
                    <p>
                      Insurance services are being provided on choice at minimal
                      cost for baggage transfers.
                    </p>
                  </div>
                  {/* <div className="link-btn">
                    <a href="#" className="theme-btn btn-style-four">
                      Read More
                    </a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Our Services  */}
        <section className="testimonial-page sp-seven">
          <div className="container">
            <div className="sec-title-one centered mb-50">
              {/* <h5>Our Services</h5> */}
              <h2>
                <span>Our</span> Services
              </h2>
            </div>
            <div className="row">
              <div className="col-xl-4 col-md-6 col-sm-12 mb-50">
                <div className="testimonial-item-two testimonial-item-two-new mt-35">
                  <i className="flaticon-left-quote"></i>
                  <a href="#">
                    <h6>Door to airport</h6>
                  </a>
                  <p>
                    Get more and pay less for excellent services of
                    carrymybaggage. Avoid checking baggage with the airlines...
                  </p>
                  <Link to='/services/door-to-airport'>
                  <span>Read More</span>
                  </Link>
                </div>
              </div>

              <div className="col-xl-4 col-md-6 col-sm-12 mb-50 ">
                <div className="testimonial-item-two testimonial-item-two-new mt-35">
                  <i className="flaticon-left-quote"></i>
                  <a href="#">
                    <h6>Airport to Door</h6>
                  </a>
                  <p>
                    If you wish your baggage to be collected from the airport
                    and being delivered to the destination...
                  </p>
                  <Link to='/services/airport-to-door'>
                  <span>Read More</span>
                  </Link>
                </div>
              </div>

              <div className="col-xl-4 col-md-6 col-sm-12 mb-50">
                <div className="testimonial-item-two testimonial-item-two-new mt-35">
                  <i className="flaticon-left-quote"></i>
                  <a href="#">
                    <h6>International Luggage Shipping</h6>
                  </a>
                  <p>
                    Travelling has never been easy and so is shipping.
                    Carrymybaggage was introduced with a vision to simplify...{" "}
                  </p>
                  <Link to='/services/international-luggage-shipping'>
                  <span>Read More</span>
                  </Link>                </div>
              </div>

              <div className="col-xl-4 col-md-6 col-sm-12 mb-50">
                <div className="testimonial-item-two testimonial-item-two-new mt-35">
                  <i className="flaticon-left-quote"></i>
                  <a href="#">
                    <h6>Unaccompanied Baggage</h6>
                  </a>
                  <p>
                    Keeping in mind the airline’s restrictive weight allowances
                    you are left with two options...{" "}
                  </p>
                  <Link to='/services/unaccompanied-baggage'>
                  <span>Read More</span>
                  </Link>  
                                  </div>
              </div>

              <div className="col-xl-4 col-md-6 col-sm-12 mb-50">
                <div className="testimonial-item-two testimonial-item-two-new mt-35">
                  <i className="flaticon-left-quote"></i>
                  <a href="#">
                    <h6>Extra Baggage Cost</h6>
                  </a>
                  <p>
                  If you are a student traveling abroad or any other person simply relocating for work or education...{" "}
                  </p>
                  <Link to='/services/extra-baggage-cost'>
                  <span>Read More</span>
                  </Link>                  </div>
              </div>

              <div className="col-xl-4 col-md-6 col-sm-12 mb-50">
                <div className="testimonial-item-two testimonial-item-two-new mt-35">
                  <i className="flaticon-left-quote"></i>
                  <a href="#">
                    <h6>Excess baggage</h6>
                  </a>
                  <p>
                    Baggage weighing more than the limit allowed on an aircraft
                    and liable to an extra charge...{" "}
                  </p>
                  <Link to='/services/excess-baggage-delivery'>
                  <span>Read More</span>
                  </Link>                  </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us  */}
        <section ref={chooseUsSection}  className="why-chooseus sp-four section-main-mobile-view">
          <div className="container mobile-view-hide">
            <div className="row">
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div className="choose-left-content">
                  <div className="sec-title-one">
                    {/* <h5>Our Qualification</h5> */}
                    <h2>
                      <span>Why People</span>
                      <br /> Choose Us?
                    </h2>
                  </div>
                  <div className="text mt-45">
                    <p >
                    Choosing the right shipping partner is crucial for your baggage’s transit, and that's where we stand out. At Carry My Baggage, we combine expertise, innovation, and customer-centric solutions to deliver reliable service every step of the way. From cost-effective baggage transportation options to convenience and reliability, we’ve got your back every step of the way. Here's why people trust us to move what matters most.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div className="choose-right-area">
                  <figure>
                    <img
                      src={require("../../../images/resource/shoose-us-1.jpg")}
                      alt=""
                    />
                  </figure>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faLaptop} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Technology</a>
                  </h6>
                  <span>
                    Latest technology to keep you updated throughout the
                    process.
                  </span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                  <div className="icon-box">
                    <FontAwesomeIcon className="fa fa-light flaticon-exercise" icon={faUsers} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Trained Staff</a>
                  </h6>
                  <span>Well trained staff to handle your goods.</span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faShieldHalved} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Security</a>
                  </h6>
                  <span>
                    The most rigorous controls on security and safety of your
                    goods.
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faCartFlatbedSuitcase} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Service</a>
                  </h6>
                  <span>Highest level of service standards.</span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faHourglassStart} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Short Transit Time</a>
                  </h6>
                  <span>Shorter transit time and timely delivery.</span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faIndianRupeeSign} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Pricing</a>
                  </h6>
                  <span>A highly competitive price.</span>
                </div>
              </div>
            </div>
          </div>
          <div className="container mobile-view-show">
            <div className="row">
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div style={{marginBottom:"0px"}} className="choose-left-content">
                  <div style={{marginBottom:"26px"}} className="sec-title-one">
                    {/* <h5>Our Qualification</h5> */}
                    <h2>
                      <span>Why People</span>
                      <br /> Choose Us?
                    </h2>
                  </div>
                  <div style={{marginBottom:"0px"}} className="choose-right-area">
                  <figure>
                    <img
                      src={require("../../../images/resource/shoose-us-1.jpg")}
                      alt=""
                    />
                  </figure>
                </div>
                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-sm-12 py-0">
                <div style={{marginBottom:"0px"}} className="choose-left-content">
                  <div className="text">
                    <p style={{marginTop:'22px'}}>
                    
                    Choosing the right shipping partner is crucial for your baggage’s transit, and that's where we stand out. At Carry My Baggage, we combine expertise, innovation, and customer-centric solutions to deliver reliable service every step of the way. From cost-effective baggage transportation options to convenience and reliability, we’ve got your back every step of the way. Here's why people trust us to move what matters most.
                    </p>
                  </div>
                </div>
              </div>
            
            </div>
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faLaptop} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Technology</a>
                  </h6>
                  <span>
                    Latest technology to keep you updated throughout the
                    process.
                  </span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                  <div className="icon-box">
                    <FontAwesomeIcon className="fa fa-light flaticon-exercise" icon={faUsers} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Trained Staff</a>
                  </h6>
                  <span>Well trained staff to handle your goods.</span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faShieldHalved} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Security</a>
                  </h6>
                  <span>
                    The most rigorous controls on security and safety of your
                    goods.
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faCartFlatbedSuitcase} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Service</a>
                  </h6>
                  <span>Highest level of service standards.</span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faHourglassStart} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Short Transit Time</a>
                  </h6>
                  <span>Shorter transit time and timely delivery.</span>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <div className="shoose-item-one mt-50">
                <div className="icon-box">
                    <FontAwesomeIcon className="fa flaticon-exercise" icon={faIndianRupeeSign} />
                    {/* <i className="flaticon-exercise"></i> */}
                  </div>
                  <h6>
                    <a href="#">Pricing</a>
                  </h6>
                  <span>A highly competitive price.</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials  */}
        <section className="our-history sp-three">
      <div className="container mobile-view-hide">
        <div className="row clearfix">
          <div className="col-xl-7 col-md-12 col-sm-12">
            <div className="image-box text-center">
              <figure>
                <img
                  src={require("../../../images/resource/testimonial.jpg")}
                  alt="Customer Testimonial"
                />
              </figure>
            </div>
          </div>
          <div style={{marginTop:'25px'}} className="col-xl-5 col-md-12 col-sm-12">
            <div className="">
              <div className="sec-title-one">
                <h2>
                  <span>What our</span> <br />
                  customers think
                </h2>
              </div>
              <div className="text mt-40 mb-40">{currentTestimonial.text}</div>
              <h6>{currentTestimonial.author}</h6>
            </div>
          </div>
        </div>
        <div className="text-end slider-pager flex justify-between mt-1">
          <FontAwesomeIcon icon={faArrowLeft}
          style={{cursor:"pointer"}}
            onClick={handleNext}
            className="fa px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Prev
          </FontAwesomeIcon>
          <FontAwesomeIcon icon={faArrowRight}
             style={{cursor:"pointer"}}
            onClick={handlePrev}
            className="fa px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Prev
          </FontAwesomeIcon>
        </div>
      </div>
      <div className="container mobile-view-show">
        <div className="row clearfix">
          <div className="col-xl-6 col-md-12 col-sm-12" >
          <div className="sec-title-one">
                <h2>
                  <span>What our</span> <br />
                  customers think
                </h2>
              </div>
            <div style={{marginBottom:'14px'}} className="image-box text-center">
              <figure>
                <img style={{marginTop:'16px',marginBottom:'0px'}}
                  src={require("../../../images/resource/testimonial.jpg")}
                  alt="Customer Testimonial"
                />
              </figure>
            </div>
          </div>
          <div className="col-xl-6 col-md-12 col-sm-12">
            <div style={{marginLeft:'0px'}} className="image-content">

              <div className="text mb-40">{currentTestimonial.text}</div>
              <h6>{currentTestimonial.author}</h6>
            </div>
          </div>
        </div>
        <div className="text-end slider-pager flex justify-between mt-1">
          <FontAwesomeIcon icon={faArrowLeft}
          style={{cursor:"pointer"}}
            onClick={handleNext}
            className="fa px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Prev
          </FontAwesomeIcon>
          <FontAwesomeIcon icon={faArrowRight}
             style={{cursor:"pointer"}}
            onClick={handlePrev}
            className="fa px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          >
            Prev
          </FontAwesomeIcon>
        </div>
      </div>
    </section>

{/* Contact Us  */}
        <section className="Appointment-form">
          <div className="container mobile-view-hide">
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-sm-12">
                <figure>
                  <img
                    src={require("../../../images/resource/appointment.jpg")}
                    alt=""
                  />
                </figure>
              </div>
              <div className="col-xl-8 col-lg-6 col-sm-12">
                <div className="default-form-area sp-ten">
                  <div className="sec-title-one mb-45">
                    {/* <h5>    Query Now</h5> */}
                    <h2 >
                      <span>Make An</span>
                      <br />
                      Appointment
                    </h2>
                  </div>
                  <form style={{paddingTop:'20px'}}
                    id="contact-form"
                    name="contact_form"
                    className="contact-form"
                  >
                    <div className="row clearfix">
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="firstName"
                            className="form-control"
                            // value={formData.firstName}
                            placeholder="First Name"
                            required=""
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="lastName"
                            className="form-control"
                            value={formData.lastName}
                            placeholder="Last Name"
                            required=""
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            className="form-control required email"
                            value={formData.email}
                            placeholder="Your Email"
                            required=""
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <textarea
                            name="message"
                            value={formData.message}
                            className="form-control textarea required"
                            placeholder="Your Message"
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="contact-section-btn mt-20">
                      <div className="form-group">
                        <input
                          id="form_botcheck"
                          name="form_botcheck"
                          className="form-control"
                          type="hidden"
                          value=""
                        />
                        <button  onClick={handleSubmit}
                          className="theme-btn btn-style-three"
                          type="submit"
                          data-loading-text="Please wait..."
                        >
                          Submit Now
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="container mobile-view-show">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-sm-12">
              <div className="sec-title-one mb-45">
                    {/* <h5>    Query Now</h5> */}
                    <h2 style={{marginTop:'21px'}} >
                      <span>Make An</span>
                      <br />
                      Appointment
                    </h2>
                  </div>
                <figure>
                  <img style={{maxWidth:'100%'}}
                    src={require("../../../images/resource/appointment.jpg")}
                    alt=""
                  />
                </figure>
              </div>
              <div className="col-xl-6 col-lg-6 col-sm-12">
                <div style={{paddingLeft:'0px',paddingTop:'5px'}} className="default-form-area sp-ten">
                 
                  <form style={{paddingTop:'20px'}}
                    id="contact-form"
                    name="contact_form"
                    className="contact-form"
                  >
                    <div className="row clearfix">
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="firstName"
                            className="form-control"
                            // value={formData.firstName}
                            placeholder="First Name"
                            required=""
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 col-xs-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="lastName"
                            className="form-control"
                            value={formData.lastName}
                            placeholder="Last Name"
                            required=""
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            className="form-control required email"
                            value={formData.email}
                            placeholder="Your Email"
                            required=""
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <textarea
                            name="message"
                            value={formData.message}
                            className="form-control textarea required"
                            placeholder="Your Message"
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="contact-section-btn mt-20">
                      <div className="form-group">
                        <input
                          id="form_botcheck"
                          name="form_botcheck"
                          className="form-control"
                          type="hidden"
                          value=""
                        />
                        <button  onClick={handleSubmit}
                          className="theme-btn btn-style-three"
                          type="submit"
                          data-loading-text="Please wait..."
                        >
                          Submit Now
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
      <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick={false}
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
/>
      <Footer scrollToWhatMakesDiffSection={scrollToWhatMakesDiffSection} scrollToChooseUsSection={scrollToChooseUsSection} />
    </div>
  );
}

export default Home;
